import angular from "angular";
import { machineManufacturerLookupConfig } from "./machineManufacturer";
import { machineCabinetTypeLookupConfig } from "./machineCabinetType";
import { machineDenominationLookupConfig } from "./denomination";
import { machineThemeLookupConfig } from "./theme";
import { modelNumberLookupConfig } from "./modelNumber";
import { gameTypeLookupConfig } from "./gameType";
import { buttonPanelLookupConfig } from "./buttonPanel";
import { coinDivisionLookupConfig } from "./coinDivision";
import { validatorDivisionLookupConfig } from "./validatorDivision";
import { leaseTypeLookupConfig } from "./leaseType";
import { gameNameLookupConfig } from "./gameName";
import { calcTypeLookupConfig } from "./calcType";
import { systemTypeLookupConfig } from "./systemType";
import { progressiveTypeLookupConfig } from "./progressiveType";
import { bankConfigLookupConfig } from "./bankConfig";
import { moduleName as recordsModuleName } from "../../../../records";
import { conversionTypeLookupConfig } from "./conversionType";

export const vsModuleName = "SlotTrak.Machines.Config.Lookups";

angular
  .module(vsModuleName, [recordsModuleName])
  .config(machineDenominationLookupConfig)
  .config(machineManufacturerLookupConfig)
  .config(machineCabinetTypeLookupConfig)
  .config(machineThemeLookupConfig)
  .config(modelNumberLookupConfig)
  .config(gameTypeLookupConfig)
  .config(buttonPanelLookupConfig)
  .config(coinDivisionLookupConfig)
  .config(validatorDivisionLookupConfig)
  .config(leaseTypeLookupConfig)
  .config(gameNameLookupConfig)
  .config(calcTypeLookupConfig)
  .config(systemTypeLookupConfig)
  .config(progressiveTypeLookupConfig)
  .config(bankConfigLookupConfig)
  .config(conversionTypeLookupConfig);
